/* eslint-disable */
import React from 'react';
import { Outlet } from 'react-router-dom';
import { MyVWContextProvider } from '../../context/myVWContext';
import "../../styles/myVW.css";

const MyVWLayout: React.FC = () => (
  <MyVWContextProvider>
    <div className='myvw-app'>
      <Outlet />
    </div>
  </MyVWContextProvider>
);

export default MyVWLayout;
